import React, { useState } from 'react';
import InputRange from 'react-input-range';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import 'react-input-range/lib/css/index.css';
import THEME from '../theme';
import { Row, Col } from './Grid';
import { Input } from '.';
let tId;
const RangeInput = (props) => {
    const lang = useSelector((s) => s.lang);
    const [value, setValue] = useState(props.value);
    const isRange = typeof props.value === 'object';
    return (React.createElement(Styled, { style: props.style },
        // @ts-ignore
        React.createElement(InputRange, { maxValue: props.maxValue, minValue: props.minValue, value: value, onChange: (val) => {
                setValue(val);
                if (props.updateWhenSteady) {
                    if (tId)
                        clearTimeout(tId);
                    tId = setTimeout(() => props.onChange(val), 500);
                }
                else {
                    props.onChange(val);
                }
            } }),
        isRange && (React.createElement(StyledRow, null,
            React.createElement(Col, { width: "6" },
                React.createElement(Input, { type: "number", placeholder: lang.inputs.from, onChange: (e) => {
                        if (typeof parseNumber(e.target.value) === 'number') {
                            setValue(Object.assign(Object.assign({}, value), { min: parseNumber(e.target.value) || 0 }));
                            if (tId)
                                clearTimeout(tId);
                            tId = setTimeout(() => props.onChange(value), 500);
                        }
                    } })),
            React.createElement(Col, { width: "6" },
                React.createElement(Input, { type: "number", placeholder: lang.inputs.to, onChange: (e) => {
                        if (typeof parseNumber(e.target.value) === 'number') {
                            setValue(Object.assign(Object.assign({}, value), { max: parseNumber(e.target.value) || 0 }));
                            if (tId)
                                clearTimeout(tId);
                            tId = setTimeout(() => props.onChange(value), 500);
                        }
                    } }))))));
};
export default RangeInput;
const parseNumber = (s) => (s && parseFloat(s)) || null;
const spacing = THEME.GRID_SPACING / 2 + 8;
const Styled = styled.div `
  padding: 20px 8px;

  .input-range__slider {
    background: ${THEME.COLOR_ACCENT};
    border: 1px solid ${THEME.COLOR_ACCENT};
  }

  .input-range__track--active {
    background: ${THEME.COLOR_PRIMARY};
  }
`;
const StyledRow = styled(Row) `
  margin: 35px -${spacing}px -40px -${spacing}px;
`;
//# sourceMappingURL=RangeInput.js.map